export const megaMenuParser = (resp) => {
  const returnRef = ({ $ref }) => $ref.replace("/content/", "");

  const returnRefItem = (refObj) => resp.content[returnRef(refObj)];

  const returnDataByRef = (refObj) =>
    refObj ? returnRefItem(refObj)?.data : null;

  const returnLinkByRef = (refObj) =>
    refObj ? returnRefItem(refObj)?.links?.site : null;

  const returnAsideContent = (items) =>
    items.map((addonItem) => {
      const addonItemData = returnDataByRef(addonItem);

      if (addonItemData?.image?.$ref) {
        const image = returnDataByRef(addonItemData.image);

        addonItemData.image = {
          desktop: image?.large?.links?.site?.href,
          mobile: image?.small?.links?.site?.href,
          thumbnail: image?.thumbnail?.links?.site?.href,
          alt: image?.displayName,
        };
      }

      if (addonItemData?.buttonLink?.$ref) {
        const buttonLinkData = returnDataByRef(addonItemData.buttonLink);
        const buttonLinkHref = returnRefItem(addonItemData.buttonLink)?.links
          ?.site;
        addonItemData.buttonLink = { ...buttonLinkData, link: buttonLinkHref };
      }

      if (addonItemData?.link?.$ref) {
        const linkHref = returnRefItem(addonItemData.link)?.links?.site?.href;
        addonItemData.link = linkHref;
      }

      return addonItemData;
    });

  const processMenuItems = (items) => {
    if (!items) {
      return [];
    }

    const finalMenu = [];

    items.forEach((item) => {
      const level = returnDataByRef(item);
      const sublevels = processMenuItems(level.sublevel);
      const { addondisplay } = level;

      if (addondisplay?.length) {
        level.isAside = true;
        level.items = returnAsideContent(addondisplay);
      }

      const asideIndex = sublevels.findIndex((item) => item.isAside);

      if (asideIndex > -1) {
        level[sublevels[asideIndex].name] = sublevels[asideIndex];
        level.asideMenuName = sublevels[asideIndex].menuname;
        sublevels.splice(asideIndex, 1);
      }

      level.sublevel = sublevels;

      finalMenu.push({ ...level, link: returnLinkByRef(level.link) });
    });

    return finalMenu;
  };

  const documentMenu = returnDataByRef(resp.document)?.menu;

  return processMenuItems(documentMenu);
};
